import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import styled from 'styled-components';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StaticIcon from '../StaticIcon';
var Wrapper = styled.div.withConfig({
  displayName: "Select__Wrapper",
  componentId: "xwuzww-0"
})(["\n  display: inline-block;\n  width: ", ";\n  min-width: 185px;\n  color: ", ";\n  vertical-align: top;\n"], function (props) {
  return props.fullWidth ? '100%' : 'auto';
}, function (props) {
  return props.white ? '#fff' : 'inherit';
});
var Label = styled.div.withConfig({
  displayName: "Select__Label",
  componentId: "xwuzww-1"
})(["\n  font-size: 10px;\n  font-weight: normal;\n  line-height: 21px;\n  text-transform: uppercase;\n  color: ", ";\n  transition: 0.2s ease transform, 0.2s ease font-size;\n  cursor: text;\n"], function (props) {
  return props.white ? '#fff' : '#7d7d7d';
});
var Caret = styled(StaticIcon).withConfig({
  displayName: "Select__Caret",
  componentId: "xwuzww-2"
})(["\n  position: absolute;\n  right: 0;\n  bottom: 15px;\n  color: ", ";\n"], function (props) {
  return props.white ? '#fff' : '#000';
});
var LabelWrapper = styled.label.withConfig({
  displayName: "Select__LabelWrapper",
  componentId: "xwuzww-3"
})(["\n  display: flex;\n  flex-direction: column-reverse;\n  position: relative;\n"]);
var SelectElement = styled.select.withConfig({
  displayName: "Select__SelectElement",
  componentId: "xwuzww-4"
})(["\n  -webkit-appearance: none;\n  appearance: none;\n  outline: 0;\n  background-color: transparent;\n  border: 0;\n  border-radius: 0;\n  border-bottom: 2px solid\n    ", ";\n  color: ", ";\n  padding: 0 30px 8px 0;\n  width: 100%;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 21px;\n  position: relative;\n  z-index: 2;\n\n  @media (max-width: 1024px) {\n    /* Necessary to prevent browsers like Mobile Safari from zooming in on text\n       fields when font-size is less than 16px. */\n    font-size: 16px;\n  }\n\n  ~ ", " {\n    color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n\n    ~ ", ", ~ ", " {\n      /* Color the label and icon too. */\n      color: ", ";\n    }\n  }\n\n  option {\n    color: #000;\n  }\n\n  option[disabled] {\n    display: none;\n  }\n"], function (props) {
  return props.error ? '#e35d6d' : props.white ? '#fff' : '#000';
}, function (props) {
  return props.white ? '#fff' : '#000';
}, Caret, function (props) {
  return props.error ? '#e35d6d' : props.white ? '#fff' : '#000';
}, function (props) {
  return props.theme.focusColor || '#7c89d3';
}, Label, Caret, function (props) {
  return props.theme.focusColor || '#7c89d3';
});
var Footer = styled.div.withConfig({
  displayName: "Select__Footer",
  componentId: "xwuzww-5"
})(["\n  min-height: ", "px;\n  margin: 4px 0 0 0;\n  font-size: 10px;\n  line-height: 1.5;\n  color: ", ";\n"], function (props) {
  return props.hint ? 30 : 15;
}, function (props) {
  return props.white ? '#fff' : 'inherit';
});
var Hint = styled.p.withConfig({
  displayName: "Select__Hint",
  componentId: "xwuzww-6"
})(["\n  margin: 0;\n"]);
var Error = styled.p.withConfig({
  displayName: "Select__Error",
  componentId: "xwuzww-7"
})(["\n  margin: 0;\n  color: ", ";\n"], function (props) {
  return props.theme.errorColor || '#e35d6d';
});

var Select =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Select, _Component);

  function Select() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Select.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var onMount = this.props.onMount;
    onMount && onMount(this.input);
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        className = _this$props.className,
        error = _this$props.error,
        hint = _this$props.hint,
        label = _this$props.label,
        onChange = _this$props.onChange,
        options = _this$props.options,
        placeholder = _this$props.placeholder,
        white = _this$props.white,
        value = _this$props.value,
        id = _this$props.id,
        fullWidth = _this$props.fullWidth,
        props = _objectWithoutPropertiesLoose(_this$props, ["className", "error", "hint", "label", "onChange", "options", "placeholder", "white", "value", "id", "fullWidth"]);

    return React.createElement(Wrapper, {
      className: className,
      fullWidth: fullWidth
    }, React.createElement(LabelWrapper, {
      htmlFor: id
    }, React.createElement(SelectElement, _extends({
      value: value,
      onChange: onChange,
      id: id,
      white: white
    }, props, {
      ref: function ref(input) {
        return _this.input = input;
      },
      error: error
    }), placeholder ? React.createElement("option", {
      value: "",
      disabled: true
    }, placeholder) : null, options.map(function (option) {
      return React.createElement("option", {
        value: option.value,
        key: option.value
      }, option.name);
    })), label ? React.createElement(Label, {
      white: white
    }, label) : null, React.createElement(Caret, {
      size: 8,
      type: "caret",
      onClick: this.onClick
    })), React.createElement(Footer, {
      error: error,
      white: white,
      hint: hint
    }, hint ? React.createElement(Hint, null, hint) : null, error ? React.createElement(Error, null, error) : null));
  };

  return Select;
}(Component);

_defineProperty(Select, "Label", Label);

_defineProperty(Select, "SelectElement", SelectElement);

_defineProperty(Select, "Caret", Caret);

_defineProperty(Select, "Footer", Footer);

_defineProperty(Select, "Hint", Hint);

_defineProperty(Select, "Error", Error);

_defineProperty(Select, "propTypes", {
  /**
   * Array of options [{ name: "Name", value: "value" }]
   */
  options: PropTypes.array.isRequired,

  /**
   * Optional label for select
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),

  /**
   * Current value
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * onchange callback
   */
  onChange: PropTypes.func,

  /**
   * Make input white
   */
  white: PropTypes.bool,

  /**
   * Make input white
   */
  fullWidth: PropTypes.bool,

  /**
   * Optional placeholder
   */
  placeholder: PropTypes.string,

  /**
   * Optional hint message
   */
  hint: PropTypes.string
});

export { Select as default };